import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const GeneralHistoryListPage = Loadable(
  lazy(() => import("../../MainAppView/GeneralHistory/GeneralHistoryListPage")),
);
const GeneralHistoryViewPage = Loadable(
  lazy(() => import("../../MainAppView/GeneralHistory/GeneralHistoryViewPage")),
);
const GeneralStatusHistoryListPage = Loadable(
  lazy(() => import("../../MainAppView/GeneralStatusHistory/GeneralStatusHistoryListPage")),
);
const GeneralStatusHistoryViewPage = Loadable(
  lazy(() => import("../../MainAppView/GeneralStatusHistory/GeneralStatusHistoryViewPage")),
);

export function HistoryRoutes() {
  return (
    <>
      {/* GeneralHistory */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.GeneralHistoryRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.GENERAL_HISTORY_LIST())}
        render={() => <GeneralHistoryListPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.GeneralHistoryRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.GENERAL_HISTORY_VIEW())}
        render={() => <GeneralHistoryViewPage />}
      />

      {/* GeneralStatusHistory */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.GeneralStatusHistoryRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.GENERAL_STATUS_HISTORY_LIST())}
        render={() => <GeneralStatusHistoryListPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.GeneralStatusHistoryRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.GENERAL_STATUS_HISTORY_VIEW())}
        render={() => <GeneralStatusHistoryViewPage />}
      />
    </>
  );
}
